import React from "react";

function NavbarMenuButton({ open = false, onClick, ariaLabel, ariaControls }) {
  return (
    <button
      type="button"
      className="navbar-menu-btn"
      aria-label={ariaLabel}
      aria-controls={ariaControls}
      aria-haspopup="true"
      aria-expanded={open}
      onClick={onClick}
    >
      <span className="navbar-hamburger" aria-hidden="true">
        <span className="navbar-hamburger-bar navbar-hamburger-bar--top" />
        <span className="navbar-hamburger-bar navbar-hamburger-bar--mid" />
        <span className="navbar-hamburger-bar navbar-hamburger-bar--bot" />
      </span>
    </button>
  );
}

export default NavbarMenuButton;
